import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {httpDeleteProject} from '@/features/projects/http/projects.http'

export const useDeleteProject = (projectId: string, options?: Omit<UseMutationOptions, 'mutationFn'>) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_PROJECT],
        mutationFn: () => httpDeleteProject({urlParams: {projectId}}),
        ...options,
        // The project is gone: the project lookups of the medical record report flow must not keep offering it.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS_BY_PATIENT]})
            options?.onSuccess?.(data, variables, context)
        }
    })
